import { TextStyle } from '../../../../../../types'
import { ArtboardTextLayerProps } from '../../../../../artboard-gl/types'
import { DEFAULT_CAPTION_STYLE } from '../../../../constants'
import { UGELayer } from '../../../../types'
import { cssFromTextStyle } from '../../../../utilities/text-style'

type Props = {
    className?: string
    layer: UGELayer
}

const UGELayersEditorLayerHeaderTitle = ({ className, layer }: Props) => {
    function getTitle() {
        if (layer.type === 'text') {
            const props = layer.props as ArtboardTextLayerProps
            const textStyle: TextStyle = { ...DEFAULT_CAPTION_STYLE, ...props }
            const style = cssFromTextStyle(textStyle)

            return <span style={style}>{(layer.props as ArtboardTextLayerProps).text}</span>
        }

        return layer.name
    }

    return <span className={className}>{getTitle()}</span>
}

export default UGELayersEditorLayerHeaderTitle
